export const GENERATE_REPORT_REQUEST = "GENERATE_REPORT_REQUEST";
export const GENERATE_REPORT_RECEIVE = "GENERATE_REPORT_RECEIVE";
export const GENERATE_REPORT_FAILURE = "GENERATE_REPORT_FAILURE";
export const RESET_GENERATE_REPORT = "RESET_GENERATE_REPORT";
